import { createReducer, on } from '@ngrx/store';

import { VouchersActions } from './vouchers.actions';
import { VouchersState } from './vouchers.state';

export const initVouchersState: VouchersState = {
  voucher: null,
  generateVoucher: {
    loading: false,
    loaded: false,
    error: null,
  },
  voucherStatus: null,
  validateVoucher: {
    loading: false,
    loaded: false,
    error: null,
  },
};

export const vouchersReducer = createReducer(
  initVouchersState,

  on(
    VouchersActions.GenerateVoucher,
    (state): VouchersState => ({
      ...state,
      voucher: null,
      generateVoucher: {
        loading: true,
        loaded: false,
        error: null,
      },
    })
  ),

  on(
    VouchersActions.GenerateVoucherSuccess,
    (state, { voucherCode }): VouchersState => ({
      ...state,
      voucher: voucherCode,
      generateVoucher: {
        error: null,
        loading: false,
        loaded: true,
      },
    })
  ),

  on(
    VouchersActions.GenerateVoucherError,
    (state, { error }): VouchersState => ({
      ...state,
      generateVoucher: {
        error,
        loading: false,
        loaded: true,
      },
    })
  ),

  on(
    VouchersActions.ValidateVoucher,
    (state): VouchersState => ({
      ...state,
      voucherStatus: null,
      validateVoucher: {
        loading: true,
        loaded: false,
        error: null,
      },
    })
  ),

  on(
    VouchersActions.ValidateVoucherSuccess,
    (state, { status }): VouchersState => ({
      ...state,
      voucherStatus: status,
      validateVoucher: {
        error: null,
        loading: false,
        loaded: true,
      },
    })
  ),

  on(
    VouchersActions.ValidateVoucherError,
    (state, { error }): VouchersState => ({
      ...state,
      validateVoucher: {
        error,
        loading: false,
        loaded: true,
      },
    })
  ),

  on(
    VouchersActions.ClearState,
    (): VouchersState => ({
      ...initVouchersState,
    })
  )
);
